// DialogTrail Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Recaptcha from 'react-google-recaptcha'

import Dialog from '../../layout/dialog/dialog.jsx'
import Button from '../../common/button/button.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import Checkbox from '../../form/checkbox/checkbox.jsx'
import InputAlt from '../../form/input_alt/input_alt.jsx'
import Select from '../../form/select/select.jsx'
import Util from '../../../lib/util.jsx'
import Loader from '../../../common/common/loader/loader.jsx'

class DialogTrail extends Component {
  constructor (props) {
    super(props)

    let currLanguage = 'EN'
    let country = props.country ? props.country.toUpperCase() : ''
    if (country) {
      if (country === 'NL') {
        currLanguage = 'NL'
      } else if (country === 'DE') {
        currLanguage = 'DE'
      } else if (country === 'UK') {
        currLanguage = 'EN'
      } else if (country === 'US') {
        currLanguage = 'US'
      }
    } else {
      country = 'UK'
    }

    this.state = {
      active: false,
      contHgt: null,
      currStep: 1,
      companyName: '',
      email: '',
      startEmpty: false,
      firstName: '',
      lastName: '',
      country: country,
      language: currLanguage,
      phone: '',
      password: '',
      confirmPassword: '',
      bPassword: false,
      bUserExists: false,
      bTermsAgree: false
    }

    this.data = {
      countries: [
        { label: 'common.form.countryNederlands', value: 'NL' },
        { label: 'common.form.countryGermany', value: 'DE' },
        { label: 'common.form.countryEnglish', value: 'UK' }
      ]
    }

    if (country === 'US') {
      this.data.countries.push({
        label: 'common.form.countryUnitedStates',
        value: 'US'
      })
    }

    this._recaptcha = null
    this._recaptchaEnabled = !!props.recaptchaEnabled
    this._references = {
      inputCompanyName: React.createRef(),
      inputEmail: React.createRef(),
      inputFirstName: React.createRef(),
      inputLastName: React.createRef(),
      inputPassword: React.createRef(),
      inputConfirmPassword: React.createRef(),
      inputUserPassword: React.createRef()
    }
    this._bUnMounted = false
  }

  static get propTypes () {
    return {
      recaptchaEnabled: PropTypes.bool,
      target: PropTypes.object,
      country: PropTypes.string,
      onSubmit: PropTypes.func,
      onUpdateEmail: PropTypes.func,
      onResendEmail: PropTypes.func,
      onShowError: PropTypes.func,
      onClose: PropTypes.func,
      showLogin: PropTypes.bool,
      checkUserExists: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      recaptchaEnabled: false,
      target: null,
      country: null,
      onSubmit: null,
      onUpdateEmail: null,
      onResendEmail: null,
      onShowError: null,
      onClose: null,
      showLogin: false,
      checkUserExists: null
    }
  }

  componentDidMount () {
    window.addEventListener('resize', this.handleResize.bind(this))
    this.handleResize()
  }

  componentWillUnmount () {
    this._bUnMounted = true
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize () {
    // If component already unmounted, dont update state
    if (this._bUnMounted) return

    const minheight = this.getWindowHeight()
    this.setState({ contHgt: { height: minheight } })
  }

  getWindowHeight () {
    const windowHgt = window.innerHeight + 'px'

    return windowHgt
  }

  show () {
    // If component already unmounted, dont update state
    if (this._bUnMounted) return

    FabButtonManager.setVisible(false)
    this.setState({ active: true })
  }

  hide () {
    // If component already unmounted, dont update state
    if (this._bUnMounted) return

    FabButtonManager.setVisible(true)
    this.setState({
      active: false,
      currStep: 1,
      companyName: '',
      email: '',
      startEmpty: false,
      firstName: '',
      lastName: '',
      country: '',
      language: 'EN',
      phone: '',
      password: '',
      confirmPassword: ''
    })

    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  showError (msgIdent) {
    if (this.props.onShowError) {
      this.props.onShowError(msgIdent)
    }
  }

  render () {
    return (
      <Dialog className='dialog-trail' active={this.state.active} modal={false}>
        <div className='dialog-trailcont' style={this.state.contHgt}>
          <div className='header'>
            <img
              src='/images/common/signup_logo.png'
              alt='Rodeo'
              className='inline-image'
            />
            <span className='splitter' />
            <h2 className='title'>
              <i className='icon icon-register-account' />
              <IntlMessage ident='common.demosignup.title' />
            </h2>
            <span className='actclose' onClick={this._onClickClose.bind(this)}>
              <i className='icon icon-popup-registerclose' />
            </span>
          </div>
          {this._renderCompanyForm()}
          {this._renderUserForm()}
          {this._renderPasswordForm()}
          {this._renderUserExistsForm()}
          {this._renderConfirmEmail()}
          {this._renderResendEmail()}
        </div>
      </Dialog>
    )
  }

  _renderCompanyForm () {
    const formClass = classnames('inviteform', {
      inviteform_show: this.state.currStep === 1,
      inviteform_animatecont: this.state.bAnimateContent,
      inviteform_animateall: !this.state.bAnimateContent
    })

    return (
      <div className={formClass}>
        <form
          action='#'
          method='post'
          noValidate
          onSubmit={this._onSubmitCompanyForm.bind(this)}
        >
          <div className='typo'>
            <h1 className='title'>
              <IntlMessage ident='common.demosignup.signupTitle' />
            </h1>
            <div className='content'>
              <p>
                <IntlMessage ident='common.demosignup.subInfo' />
              </p>
            </div>
          </div>
          <div className='formcontent'>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.signupTeam.placeholderCompanyName' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='text'
                  name='companyName'
                  size={10}
                  maxLength={100}
                  label='user.signupTeam.placeholderCompanyName'
                  ref={this._references.inputCompanyName}
                  required
                  validations={['required']}
                  value={this.state.companyName}
                  onChange={this._onChangeInput.bind(this, 'companyName')}
                />
              </div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.signupTeam.placeholderEmail' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='text'
                  name='email'
                  size={10}
                  maxLength={100}
                  label='user.signupTeam.placeholderEmail'
                  ref={this._references.inputEmail}
                  required
                  validations={['required', 'email']}
                  value={this.state.email}
                  onChange={this._onChangeInput.bind(this, 'email')}
                />
              </div>
            </div>
            <div className='formrow check'>
              <div className='formfield'>
                <Checkbox
                  label='common.demosignup.checkboxInfo'
                  checked={this.state.startEmpty}
                  icon='register'
                  onChange={this._onChangeInput.bind(this, 'startEmpty')}
                />
              </div>
            </div>
          </div>
          <div className='formact'>
            <button type='submit' style={{ display: 'none' }}>
              <IntlMessage ident='user.signupTeam.submit' />
            </button>
            <IconButton
              type='primary'
              size='big'
              icon='signup-next'
              title='user.signupTeam.titleNext'
              className='signup'
              canHover={false}
              onClick={this._onSubmitCompanyForm.bind(this)}
            />
          </div>
        </form>
      </div>
    )
  }

  _renderUserForm () {
    const formClass = classnames('inviteform user', {
      inviteform_show: this.state.currStep === 2,
      inviteform_animatecont: this.state.bAnimateContent,
      inviteform_animateall: !this.state.bAnimateContent
    })

    return (
      <div className={formClass}>
        <form
          action='#'
          method='post'
          noValidate
          onSubmit={this._onSubmitUserForm.bind(this)}
        >
          <div className='typo'>
            <h1 className='title'>
              <IntlMessage ident='common.demosignup.userTitle' />
            </h1>
            <div className='content'>
              <p>
                <IntlMessage ident='common.demosignup.subInfo' />
              </p>
            </div>
          </div>
          <div className='formcontent'>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.signupTeam.placeholderFirstName' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='text'
                  name='firstName'
                  size={10}
                  maxLength={100}
                  label='user.signupTeam.placeholderFirstName'
                  ref={this._references.inputFirstName}
                  required
                  validations={['required']}
                  value={this.state.firstName}
                  onChange={this._onChangeInput.bind(this, 'firstName')}
                />
              </div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.signupTeam.placeholderLastName' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='text'
                  name='lastName'
                  size={10}
                  maxLength={100}
                  label='user.signupTeam.placeholderLastName'
                  ref={this._references.inputLastName}
                  validations={['required']}
                  value={this.state.lastName}
                  onChange={this._onChangeInput.bind(this, 'lastName')}
                />
              </div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.signupTeam.placeholderCountry' />
              </div>
              <div className='formfield'>
                <Select
                  options={this.data.countries}
                  name='country'
                  multilingualOptions
                  label='user.signupTeam.placeholderCountry'
                  className='signup'
                  icon='signup-downarw'
                  onChange={this._onChangeInput.bind(this, 'country')}
                  value={this.state.country}
                />
              </div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.signupTeam.placeholderPhone' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='text'
                  name='phone'
                  size={10}
                  maxLength={100}
                  label='user.signupTeam.placeholderPhone'
                  required={false}
                  value={this.state.phone}
                  onChange={this._onChangeInput.bind(this, 'phone')}
                />
              </div>
            </div>
          </div>
          <div className='formact alt'>
            <IconButton
              type='primary'
              size='big'
              icon='register-previous'
              title='user.signupTeam.titlePrevious'
              canHover={false}
              className='register'
              onClick={this._onClickStep1.bind(this)}
            />
          </div>
          <div className='formact'>
            <button type='submit' style={{ display: 'none' }}>
              <IntlMessage ident='user.signupTeam.submit' />
            </button>
            <IconButton
              type='primary'
              size='big'
              icon='signup-next'
              title='user.signupTeam.titleNext'
              className='signup'
              canHover={false}
              onClick={this._onSubmitUserForm.bind(this)}
            />
          </div>
        </form>
      </div>
    )
  }

  _renderPasswordForm () {
    const formClass = classnames('inviteform', {
      inviteform_show: this.state.currStep === 3 && !this.state.bUserExists,
      inviteform_animatecont: this.state.bAnimateContent,
      inviteform_animateall: !this.state.bAnimateContent
    })
    const validateInfo = Util.getPasswordValidateInfo(this.state.password)

    return (
      <div className={formClass}>
        <form
          action='#'
          method='post'
          noValidate
          onSubmit={this._onSubmitPasswordForm.bind(this)}
        >
          <div className='typo'>
            <h1 className='title'>
              <IntlMessage ident='common.demosignup.passwordTitle' />
            </h1>
          </div>
          <div className='formcontent'>
            <div className='formrow'>
              <div className='typo'>
                <p>
                  <span
                    className={`infocont${
                      validateInfo.hasEightChars ? ' active' : ''
                    }`}
                  >
                    <span className='tick'>
                      <i className='icon icon-list-tick' />
                    </span>
                    <IntlMessage ident='user.signupTeam.passwordHintCharater' />
                  </span>
                  <br />
                  <span
                    className={`infocont${
                      validateInfo.hasAlphaNumeric ? ' active' : ''
                    }`}
                  >
                    <span className='tick'>
                      <i className='icon icon-list-tick' />
                    </span>
                    <IntlMessage ident='user.signupTeam.passwordHintAlphanumeric' />
                  </span>
                  <br />
                  <span
                    className={`infocont${
                      validateInfo.hasDigit ? ' active' : ''
                    }`}
                  >
                    <span className='tick'>
                      <i className='icon icon-list-tick' />
                    </span>
                    <IntlMessage ident='user.signupTeam.passwordHintDigit' />
                  </span>
                  <br />
                  <span
                    className={`infocont${
                      validateInfo.hasNoSpace ? ' active' : ''
                    }`}
                  >
                    <span className='tick'>
                      <i className='icon icon-list-tick' />
                    </span>
                    <IntlMessage ident='user.signupTeam.passwordHintSpace' />
                  </span>
                  <br />
                </p>
              </div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.signupTeam.placeholderPassword' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='password'
                  name='password'
                  size={10}
                  maxLength={100}
                  label='user.signupTeam.placeholderPassword'
                  ref={this._references.inputPassword}
                  required
                  validations={['required', 'password']}
                  value={this.state.password}
                  onChange={this._onChangeInput.bind(this, 'password')}
                />
              </div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.signupTeam.placeholderPasswordRepeat' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='password'
                  name='password'
                  size={10}
                  maxLength={100}
                  label='user.signupTeam.placeholderPasswordRepeat'
                  ref={this._references.inputConfirmPassword}
                  required
                  validations={['required', 'password']}
                  value={this.state.confirmPassword}
                  onChange={this._onChangeInput.bind(this, 'confirmPassword')}
                />
              </div>
            </div>
            <div className='formrow'>
              <div className='terms'>
                <Checkbox
                  icon='terms'
                  checked={this.state.bTermsAgree}
                  onChange={this._onChangeInput.bind(this, 'bTermsAgree')}
                />

                <div className='label'>
                  <span className='info'>
                    <IntlMessage ident='user.signupTeam.termsAndConditionInfo' />
                    &nbsp;
                  </span>
                  <a
                    className='info alt'
                    href='/common/terms_and_conditions_rodeo_software.pdf'
                    target='_blank'
                  >
                    <IntlMessage ident='user.signupTeam.termsOfServicesLabel' />
                    &nbsp;
                  </a>
                  <a
                    className='info alt'
                    href='/common/dpa_rodeo_software.pdf'
                    target='_blank'
                  >
                    <IntlMessage ident='user.signupTeam.dpaLabel' />
                    &nbsp;
                  </a>
                  <span className='info'>
                    <IntlMessage ident='user.signupTeam.termsAndConditionAnd' />
                    &nbsp;
                  </span>
                  <a
                    className='info alt'
                    href='/common/privacy_policy_rodeo_software.pdf'
                    target='_blank'
                  >
                    <IntlMessage ident='user.signupTeam.privacyPolicyLabel' />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className='grecaptchawrap'>{this._renderCaptcha()}</div>
          <div className='formact alt'>
            <IconButton
              type='primary'
              size='big'
              icon='register-previous'
              title='user.signupTeam.titlePrevious'
              canHover={false}
              className='register'
              onClick={this._onClickStep2.bind(this)}
            />
          </div>
          <div className='formact'>
            <button type='submit' style={{ display: 'none' }}>
              <IntlMessage ident='user.signupTeam.submit' />
            </button>
            <IconButton
              type='primary'
              size='big'
              icon='signup-next'
              title='user.signupTeam.submit'
              className='signup'
              canHover={false}
              onClick={this._onSubmitPasswordForm.bind(this)}
            />
          </div>
        </form>
      </div>
    )
  }

  _renderUserExistsForm () {
    const formClass = classnames('inviteform', {
      inviteform_show: this.state.currStep === 3 && this.state.bUserExists,
      inviteform_animatecont: this.state.bAnimateContent,
      inviteform_animateall: !this.state.bAnimateContent
    })

    return (
      <div className={formClass}>
        <form
          action='#'
          method='post'
          noValidate
          onSubmit={this._onSubmitUserExistsForm.bind(this)}
        >
          <div className='typo'>
            <h1 className='title'>
              <IntlMessage ident='user.signupTeam.loginTitle' />
            </h1>
          </div>
          <div className='formcontent'>
            <div className='formrow'>
              <div className='typo'>
                <p>
                  <IntlMessage ident='user.signupTeam.loginInfo' />
                </p>
              </div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.signupTeam.loginPassword' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='password'
                  name='password'
                  size={10}
                  maxLength={100}
                  label='user.signupTeam.loginPassword'
                  ref={this._references.inputUserPassword}
                  required
                  validations={['required', 'password']}
                  value={this.state.userPassword}
                  onChange={this._onChangeInput.bind(this, 'userPassword')}
                />
              </div>
            </div>
          </div>
          <div className='grecaptchawrap'>{this._renderCaptcha()}</div>
          <div className='formact alt'>
            <IconButton
              type='primary'
              size='big'
              icon='register-previous'
              title='user.signupTeam.titlePrevious'
              canHover={false}
              className='register'
              onClick={this._onClickStep3.bind(this)}
            />
          </div>
          <div className='formact'>
            <button type='submit' style={{ display: 'none' }}>
              <IntlMessage ident='user.signupTeam.submit' />
            </button>
            <IconButton
              type='primary'
              size='big'
              icon='signup-next'
              title='user.signupTeam.submit'
              className='signup'
              canHover={false}
              onClick={this._onSubmitUserExistsForm.bind(this)}
            />
          </div>
        </form>
      </div>
    )
  }

  _renderConfirmEmail () {
    const formClass = classnames('inviteform email', {
      inviteform_show: this.state.currStep === 4,
      inviteform_animatecont: this.state.bAnimateContent,
      inviteform_animateall: !this.state.bAnimateContent
    })

    return (
      <div className={formClass}>
        <div className='typo'>
          <h1 className='title'>
            <IntlMessage ident='common.demosignup.emailTitle' />
          </h1>
          <div className='info'>
            <p>
              <IntlMessage ident='common.demosignup.emailSubInfo' />
            </p>
          </div>
        </div>
        <div className='formcontent'>
          <div className='formrow'>
            <div className='formfield'>
              <InputAlt
                type='text'
                name='email'
                size={10}
                maxLength={100}
                label='user.signupTeam.placeholderEmail'
                required
                validations={['required', 'email']}
                value={this.state.email}
                className='registeremail'
                onChange={this._onChangeInput.bind(this, 'email')}
              />
            </div>
          </div>
        </div>
        <Loader size={60} color='#7abd9a' />
        <div className='bottomcontent'>
          <div className='typo'>
            <div className='content'>
              <p>
                <IntlMessage ident='common.demosignup.emailInfo' />
              </p>
            </div>
          </div>
          <div className='actions'>
            <Button
              className='button_registeremail'
              title='common.demosignup.emailChangeTitle'
              onClick={this._onChangeEmail.bind(this)}
            />
            <Button
              className='button_registeremail change'
              title='common.demosignup.emailResendTitle'
              onClick={this._onResendConfirmEmail.bind(this)}
            />
          </div>
        </div>
      </div>
    )
  }

  _renderResendEmail () {
    const formClass = classnames('inviteform email', {
      inviteform_show: this.state.currStep === 5,
      inviteform_animatecont: this.state.bAnimateContent,
      inviteform_animateall: !this.state.bAnimateContent
    })

    return (
      <div className={formClass}>
        <div className='typo'>
          <h1 className='title'>
            <IntlMessage ident='common.demosignup.emailResendMainTitle' />
          </h1>
          <div className='info'>
            <p>
              <IntlMessage ident='common.demosignup.emailSubInfo' />
            </p>
          </div>
        </div>
        <div className='formcontent'>
          <div className='formrow'>
            <div className='formfield'>
              <InputAlt
                type='text'
                name='email'
                size={10}
                maxLength={100}
                label='user.signupTeam.placeholderEmail'
                required
                validations={['required', 'email']}
                value={this.state.email}
                className='registeremail'
                onChange={this._onChangeInput.bind(this, 'email')}
              />
            </div>
          </div>
        </div>
        <Loader size={60} color='#7abd9a' />
        <div className='bottomcontent'>
          <div className='typo'>
            <div className='content'>
              <p>
                <IntlMessage ident='common.demosignup.emailInfo' />
              </p>
            </div>
          </div>
          <div className='actions'>
            <Button
              className='button_registeremail'
              title='common.demosignup.emailChangeTitle'
              onClick={this._onChangeEmail.bind(this)}
            />
            <Button
              className='button_registeremail change'
              title='common.demosignup.emailResendTitle'
              onClick={this._onResendEmail.bind(this)}
            />
          </div>
        </div>
      </div>
    )
  }

  _renderCaptcha () {
    if (this._recaptchaEnabled) {
      return (
        <Recaptcha
          ref={(el) => {
            this._recaptcha = el
          }}
          size='invisible'
          sitekey='6LdBpyEUAAAAAFPxRsQcCGTzLRtxwnHQPJh5WoU5'
          badge='bottomleft'
          onChange={this._onCaptchaVerified.bind(this)}
        />
      )
    }

    return ''
  }

  /* Event handlers */
  _onCaptchaVerified (_token) {
    this._callSubmitRegister(this.state.bUserExists)
  }

  _onClickClose (ev) {
    ev.preventDefault()
    ev.stopPropagation()
    this.hide()
  }

  _onClickStep1 (ev) {
    ev.preventDefault()
    this.setState({ currStep: 1 })
  }

  _onClickStep2 (ev) {
    ev.preventDefault()
    this.setState({ currStep: 2 })
  }

  _onClickStep3 (ev) {
    ev.preventDefault()
    this.setState({ currStep: 2, bPassword: false })
  }

  _onChangeEmail (ev) {
    ev.preventDefault()

    if (this.props.onUpdateEmail) {
      this.props.onUpdateEmail(this.state.email)
    }
  }

  _onResendConfirmEmail (ev) {
    ev.preventDefault()

    if (this.props.onResendEmail) {
      this.props.onResendEmail(this.state.email)
    }
    this.setState({ currStep: 5 })
  }

  _onResendEmail (ev) {
    ev.preventDefault()

    if (this.props.onResendEmail) {
      this.props.onResendEmail(this.state.email)
    }
  }

  _onSubmitCompanyForm (ev) {
    ev.preventDefault()
    let noErrors = 0

    if (
      this._references.inputCompanyName.current &&
      !this._references.inputCompanyName.current.validate()
    ) {
      this.showError('user.signupTeam.msgInvalidCompanyName')
      noErrors++
    } else if (
      this._references.inputEmail.current &&
      !this._references.inputEmail.current.validate()
    ) {
      this.showError('user.signupTeam.msgInvalidEmail')
      noErrors++
    }

    if (noErrors === 0) {
      this.setState({ currStep: 2 })
    }
  }

  _onSubmitUserForm (ev) {
    ev.preventDefault()
    let noErrors = 0

    if (
      this._references.inputFirstName.current &&
      !this._references.inputFirstName.current.validate()
    ) {
      this.showError('user.signupTeam.msgInvalidFirstName')
      noErrors++
    } else if (
      this._references.inputLastName.current &&
      !this._references.inputLastName.current.validate()
    ) {
      this.showError('user.signupTeam.msgInvalidLastName')
      noErrors++
    }

    if (this.props.checkUserExists && noErrors === 0) {
      this.props.checkUserExists(this.state.email, (bUserExists) => {
        this.setState({ bUserExists: bUserExists, currStep: 3 })
      })
    }
  }

  _onSubmitPasswordForm (ev) {
    if (ev) {
      ev.preventDefault()
    }

    let noErrors = 0

    if (
      this._references.inputPassword.current &&
      !this._references.inputPassword.current.validate()
    ) {
      if (!this.state.password) {
        this.showError('user.signupTeam.msgErrorPassword')
      } else {
        this.showError('user.signupTeam.msgInvalidPassword')
      }
      noErrors++
    } else if (
      this._references.inputConfirmPassword.current &&
      !this._references.inputConfirmPassword.current.validate()
    ) {
      if (!this.state.confirmPassword) {
        this.showError('user.signupTeam.msgErrorConfirmPassword')
      } else {
        this.showError('user.signupTeam.msgInvalidConfirmPassword')
      }
      noErrors++
    } else if (this.state.password !== this.state.confirmPassword) {
      this.showError('user.signupTeam.msgPasswordNotMatch')
      noErrors++
    } else if (!this.state.bTermsAgree) {
      this.showError('user.signupTeam.msgTermsAndConditionsError')
      noErrors++
    }

    if (noErrors === 0) {
      if (this._recaptchaEnabled && this._recaptcha) {
        this._recaptcha.execute()
      } else {
        this._callSubmitRegister(false)
      }
    }
  }

  _onSubmitUserExistsForm (ev) {
    if (ev) {
      ev.preventDefault()
    }

    let noErrors = 0

    if (
      this._references.inputUserPassword.current &&
      !this._references.inputUserPassword.current.validate()
    ) {
      if (!this.state.userPassword) {
        this.showError('user.signupTeam.msgErrorPassword')
      } else {
        this.showError('user.signupTeam.msgInvalidPassword')
      }
      noErrors++
    }

    if (noErrors === 0) {
      if (this._recaptchaEnabled && this._recaptcha) {
        this._recaptcha.execute()
      } else {
        this._callSubmitRegister(true)
      }
    }
  }

  _callSubmitRegister (bUserExists) {
    const registerObj = {
      companyName: this.state.companyName,
      country: this.state.country,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      language: this.state.language,
      email: this.state.email,
      password: bUserExists ? this.state.userPassword : this.state.password,
      phone: this.state.phone,
      startEmpty: this.state.startEmpty
    }

    if (this.props.onSubmit) {
      this.props.onSubmit(registerObj, bUserExists, (bSuccess) => {
        if (bSuccess && !bUserExists) {
          this.setState({ currStep: 4 })
        }
      })
    }
  }

  _onChangeInput (name, value) {
    this.setState({ [name]: value })
  }
}

export default DialogTrail
